import { AppChannel, Channel } from "@/config/channel"

import { PokerstarsHeader } from "./pokerstars"

const FactoryHeader = ({ isThankYouPage }: { isThankYouPage?: boolean }) => {
  return <PokerstarsHeader isThankYouPage={isThankYouPage} />
}

const AppChannelsWithoutHeader: Channel[] = [
  AppChannel.ClientDesktopSisalPoker,
  AppChannel.AppSisalPoker,
  AppChannel.AppCasinoHub,
  AppChannel.AppMobileScommesse,
]

export { AppChannelsWithoutHeader, FactoryHeader }
